var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\r\n      .menu-1 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-width: 2px;\r\n      }\r\n    ")),React.createElement("g",{"id":"Group_5","data-name":"Group 5","transform":"translate(-81.5 -44.5)","key":1},[React.createElement("line",{"id":"Line_4","data-name":"Line 4","className":"menu-1","x2":"38.008","transform":"translate(81.5 45.5)","key":0}),React.createElement("line",{"id":"Line_5","data-name":"Line 5","className":"menu-1","x2":"38.008","transform":"translate(81.5 58.5)","key":1}),React.createElement("line",{"id":"Line_6","data-name":"Line 6","className":"menu-1","x2":"38.008","transform":"translate(81.5 71.5)","key":2})])]);
}

Menu.defaultProps = {"width":"100%","viewBox":"0 0 38.008 28"};

module.exports = Menu;

Menu.default = Menu;
